export const generateInsertScript = (
  organisationId: number,
  jmesPathExpression: string,
  scriptType: string,
  scriptName: string
) => {
  const withoutLineBreaks = jmesPathExpression.replaceAll(/[\n\r]/g, '');
  const cleanedExpression = replaceSpecialsWithSpace(withoutLineBreaks);
  const jsonEscapedExpression = JSON.stringify({
    expression: cleanedExpression,
  });
  const finalExpression = `$orgConfigRules$${jsonEscapedExpression}$orgConfigRules$`;

  return `INSERT INTO organisation_configuration(organisation_id, type, name, rules,start_time, created_time)
VALUES (${organisationId}
 ,'${scriptType}'
 ,'${scriptName}'
 ,${finalExpression}
 ,now() + interval '5 min'
 ,now()
);`;
};

// Replaces all weird space characters (plus tab) with normal spaces
// Weird list is taken from https://unicode-explorer.com/articles/space-characters
export const replaceSpecialsWithSpace = (source: string) => {
  return source.replaceAll(
    // eslint-disable-next-line no-misleading-character-class,no-control-regex
    /[\u00A0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u200B\u200C\u200D\u2060\uFEFF\u0009]/g,
    ' '
  );
};
